import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="text-2xl font-heading font-bold text-primary-400">
              快猫短视频
            </Link>
            <p className="mt-4 text-sm text-foreground-300 leading-relaxed">
              发现精彩，记录生活。快猫短视频汇聚海量优质短视频内容，让你随时随地享受视听盛宴。
            </p>
            <div className="flex items-center gap-4 mt-5">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-primary-500 transition-colors" aria-label="微信">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-primary-500 transition-colors" aria-label="微博">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-primary-500 transition-colors" aria-label="抖音">
                <i className="ri-tiktok-line text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4">热门分类</h4>
            <div className="grid grid-cols-2 gap-2">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4">快捷链接</h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap">首页</Link>
              <Link to="/about" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap">关于我们</Link>
              <a href="#" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap">创作者入驻</a>
              <a href="#" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap">下载APP</a>
              <a href="#" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap">帮助中心</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4">联系我们</h4>
            <div className="flex flex-col gap-2">
              <span className="text-sm text-foreground-300 whitespace-nowrap">邮箱：support@kuaimao.com</span>
              <span className="text-sm text-foreground-300 whitespace-nowrap">电话：400-888-6666</span>
              <span className="text-sm text-foreground-300 whitespace-nowrap">地址：北京市朝阳区望京科技园</span>
            </div>
          </div>
        </div>

        <div className="border-t border-foreground-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-400">
            &copy; 2020-2026 快猫短视频 版权所有 | 
            <a href="#" className="hover:text-primary-400 transition-colors ml-1">京ICP备XXXXXXXX号</a>
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">用户协议</a>
            <a href="#" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">隐私政策</a>
            <a href="#" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">社区规范</a>
          </div>
        </div>
      </div>
    </footer>
  );
}